import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestLicenseTelemetryGet = {
    path: "/plugin-update/:slug/telemetry/:blogId",
    method: RouteHttpVerb.GET
};
export { locationRestLicenseTelemetryGet };
